import type { Level } from '../../../types';
import { css, colors } from './print.util';

export function print() {
    return function (_: object, propertyKey: string, descriptor: PropertyDescriptor) {
        const originalMethod = descriptor.value;
        const isDev = process.env.NODE_ENV === 'development';

        descriptor.value = function (...args: unknown[]) {
            const method = propertyKey as Level;
            const params = [...args];
            const ns = 'app';

            if (typeof params[0] !== 'string') params.unshift('%o');

            if (isDev) {
                console[method](
                    `%c${ns}%c ${params[0]}`,
                    css(colors[method]).join(';'),
                    'color: inherit',
                    ...params.slice(1)
                );
            } else {
                console[method](...args);
            }

            originalMethod.apply(this, args);
        };

        return descriptor;
    };
}
